import { Backdrop, Box, Button, CircularProgress, Grid, Tooltip, Typography } from '@mui/material';
import Header from './header/index.jsx';
import { GSTHeadCells, heading, inventoryDropDown, Outstandingdata, tdstcsdata } from './data';
import { useEffect, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import {
  listAccountMasterv2,
  listBankAccountsCustom,
  listCashAccountsCustom,
  listDayBookTransactionDetails,
  listDayBookTransactionsCount,
  listPlaceOfSupply,
} from '../../../graphql';
import ReportTable from './reportTable';
import { useSelector } from 'react-redux';
import ActionItems from './actionItems';
import { useFetchGstReportPurchaseQuery, useFetchGstReportSalesQuery } from '../../../redux/apis/GSTReport.api.js';
import NewOutStandingReport from '../../../components/Table/NewOutStandingReport.jsx';
import NewTDSTCSReport from '../../../components/Table/NewTDSTCSReport.jsx';
import { useThemes } from '../../../components/Theme/theme.js';
import { LocalPrintshop } from '@mui/icons-material';
import DbExportButton from '../../../components/Buttons/DbExportButton.jsx';
import { defaultRowsPerPage } from '../../../utils/common.js';
import SearchIcon from '@mui/icons-material/Search';
import ListEwayBill from '../eWayBill/listEwayBill.jsx';
import ClosingStockSummary from '../../../features/StockManagement/pages/ClosingStockSummary';
import StockItemWiseSummary from '../../../features/StockManagement/pages/StockItemWiseSummary';
import NewPayableReceivableAgeing from '../../../components/Table/NewPayableReceivableAgeing.jsx';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setDbDateRange } from '../../../redux/reducers/DashboardSlice';
const NewReports = () => {
  const { theme } = useThemes();
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  const location = useLocation();
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState([]);
  const [dayBookData, setDayBookData] = useState([]);
  const [gstData, setGSTData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(() => {
    try {
      const stored = localStorage.getItem('selectedTab');
      return stored && stored !== 'undefined' && stored !== 'null' ? JSON.parse(stored) : '';
    } catch (error) {
      console.error('Error parsing selectedTab from localStorage:', error);
      return '';
    }
  });
  const [dataCount, setdataCount] = useState(30);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [page, setPage] = useState(0);
  const [isCustomDateModalOpen, setIsCustomDateModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(() => {
    try {
      const stored = localStorage.getItem('selectedAccount');
      return stored && stored !== 'undefined' && stored !== 'null' ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error parsing selectedAccount from localStorage:', error);
      return [];
    }
  });
  const [tableData, setTableData] = useState([]);
  const [listOfStates, setListOfStates] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [includeOpeningBalance, setIncludeOpeningBalance] = useState(true);
  const { startTimeStamp, endTimeStamp } = dashboardData?.report;

  useEffect(() => {
    if (location.state?.startTimeStamp && location.state?.endTimeStamp) {
      setSelectedTab(9);
      setSelectedAccount([
        {
          accountsid: '101',
          accountname: 'Stock Ledger',
          selectedTab: 9,
        },
      ]);

      const range = {
        startTimeStamp: location.state.startTimeStamp,
        endTimeStamp: location.state.endTimeStamp,
        period: 'year',
      };
      dispatch(
        setDbDateRange({
          outerKey: 'report',
          innerKey: 'range',
          value: range,
        })
      );
      dispatch(
        setDbDateRange({
          outerKey: 'report',
          innerKey: 'period',
          value: 'year',
        })
      );
      localStorage.setItem('selectedPeriod', 'year');
    }
  }, [location.state, dispatch]);

  const cashAccounts = async () => {
    setData([]);
    if (selectedTab === 6) {
      setSelectedAccount([]);
    }
    setLoading(true);
    const resCashAccounts = await API.graphql(graphqlOperation(listCashAccountsCustom));
    console.log(resCashAccounts, 'resCashAccounts');

    setData([...resCashAccounts.data.listCashAccounts, ...resCashAccounts.data.listBankAccounts]);
    setLoading(false);
  };
  const bankAccounts = async () => {
    setData([]);
    if (selectedTab === 6) {
      setSelectedAccount([]);
    }
    setLoading(true);
    const resBankAccounts = await API.graphql(graphqlOperation(listBankAccountsCustom));
    setLoading(false);
    setData(resBankAccounts.data.listBankAccounts);
  };
  // useEffect(() => {
  //   setData([]);
  //   setTableData([]);
  //   setDayBookData([]);
  // }, []);

  // useEffect(() => {
  //   const controlAndS = (e) => {
  //     if (e.ctrlKey && e.key.toLowerCase() === 's') {
  //       e.preventDefault();
  //     }
  //   };

  //   window.addEventListener('keydown', controlAndS);

  //   return () => {
  //     window.removeEventListener('keydown', controlAndS);
  //   };
  // }, []);
  const ledgers = async () => {
    setData([]);
    if (selectedTab === 6) {
      setSelectedAccount([]);
    }
    setLoading(true);
    const resAccounts = await API.graphql(graphqlOperation(listAccountMasterv2));
    setData(resAccounts.data.listAccountMasterv2);
    setLoading(false);
  };
  async function getStates() {
    try {
      const cities = await API.graphql(graphqlOperation(listPlaceOfSupply));
      if (cities?.data?.listPlaceOfSupply != null) {
        let statesArray = (cities?.data?.listPlaceOfSupply).map((element) => {
          return {
            label: element.StateName,
            value: element.ID,
          };
        });
        setListOfStates([...statesArray, { label: 'Outside India', value: 'Outside India' }]);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const gstReports = () => {
    setData([]);
    setTableData([]);
    setSelectedAccount([]);
    setData(GSTHeadCells);
    getStates();
  };
  const groupedData = dayBookData?.reduce((acc, row) => {
    if (!acc[row.vouchernumber]) {
      acc[row.vouchernumber] = [];
    }
    acc[row.vouchernumber].push(row);
    return acc;
  }, {});
  const uniqueVoucherNumbers = Object.keys(groupedData);
  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      if (uniqueVoucherNumbers.length !== dataCount)
        if (uniqueVoucherNumbers.length < rowsPerPage * (newPage + 1)) {
          dayBookList(false, uniqueVoucherNumbers.length, rowsPerPage);
        }
    }
    setPage(newPage);
  };
  const dayBookList = async (reset, from, to) => {
    setTableData([]);
    if (reset) {
      setDayBookData([]);
      setPage(0);
    }
    setBackdropOpen(true);
    const resActive = await API.graphql(
      graphqlOperation(listDayBookTransactionDetails, {
        startdate: startTimeStamp,
        enddate: endTimeStamp,
        rowfrom: from,
        columnname: 'enteredtimestamp',
        ordertype: 'desc',
        limitno: to,
        searcharray: '[]',
        searchmode: 0,
      })
    );
    const resCount = API.graphql(
      graphqlOperation(listDayBookTransactionsCount, {
        startdate: startTimeStamp,
        enddate: endTimeStamp,
      })
    );
    if (resActive.data.listDayBookTransactionDetails.length > 0) {
    }
    Promise.allSettled([resActive, resCount])
      .then((response) => {
        let res = response[0].value;
        let responseCount = response[1].value;
        setdataCount(parseInt(responseCount?.data?.listDayBookTransactionsCount[0].transactioncount) || 0);
        if (reset) {
          setDayBookData(res.data.listDayBookTransactionDetails);
        } else {
          setDayBookData((prevItems) => [...prevItems, ...res.data.listDayBookTransactionDetails]);
        }
        setBackdropOpen(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (dataCount > dayBookData.length && selectedTab === 4) {
      dayBookList(true, 0, rowsPerPage);
    }
  }, [rowsPerPage]);

  // GST Report data fetching
  const shouldSkipQuery = (accountId) => {
    if (selectedAccount?.[0]?.accountsid === '003') {
      return startTimeStamp && endTimeStamp && selectedTab === 6;
    }
    return startTimeStamp && endTimeStamp && selectedTab === 6 && selectedAccount?.[0]?.accountsid === accountId;
  };

  // Fetch GSTR1 Data (Sales)
  const {
    data: GSTR1Data,
    isLoading: isGSTR1Loading,
    isError: isGSTR1Error,
    error: GSTR1Error,
  } = useFetchGstReportSalesQuery(
    { startdate: startTimeStamp, enddate: endTimeStamp },
    {
      skip: !shouldSkipQuery('001'),
      refetchOnMountOrArgChange: true,
    }
  );

  // Fetch GSTR2 Data (Purchase)
  const {
    data: GSTR2Data,
    isLoading: isGSTR2Loading,
    isError: isGSTR2Error,
    error: GSTR2Error,
  } = useFetchGstReportPurchaseQuery(
    { startdate: startTimeStamp, enddate: endTimeStamp },
    {
      skip: !shouldSkipQuery('002'),
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (!selectedAccount?.[0]?.accountsid) return;
    const { accountsid } = selectedAccount[0];

    let updatedGSTData = [];

    switch (accountsid) {
      case '001':
        updatedGSTData = GSTR1Data?.length ? GSTR1Data : [];
        break;
      case '002':
        updatedGSTData = GSTR2Data?.length ? GSTR2Data : [];
        break;
      case '003':
        if (GSTR1Data?.length || GSTR2Data?.length) {
          updatedGSTData = [{ GSTR1Data, GSTR2Data }];
        }
        break;
      default:
        break;
    }

    setGSTData(updatedGSTData);
    localStorage.setItem('selectedAccount', JSON.stringify(selectedAccount));
    const handleBeforeUnload = () => {
      // Save even if it's an empty array
      localStorage.setItem('selectedAccount', JSON.stringify(selectedAccount));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [selectedAccount, GSTR1Data, GSTR2Data]);

  useEffect(() => {
    switch (selectedTab) {
      case 1:
        setGSTData([]);
        setDayBookData([]);
        cashAccounts();
        break;

      case 2:
        setGSTData([]);
        setDayBookData([]);
        bankAccounts();
        break;
      case 3:
        setGSTData([]);
        setDayBookData([]);
        ledgers();
        break;
      case 4:
        setGSTData([]);
        setSelectedAccount([]);
        setTableData([]);
        break;
      case 5:
        setGSTData([]);
        setDayBookData([]);
        setData(tdstcsdata);
        break;
      case 6:
        setDayBookData([]);
        setSelectedAccount([]);
        setTableData([]);
        gstReports();
        break;
      case 7:
        setGSTData([]);
        setDayBookData([]);
        setData(Outstandingdata);
        break;

      case 9:
        setGSTData([]);
        setDayBookData([]);
        setData(inventoryDropDown);
        break;
    }
    localStorage.setItem('selectedTab', JSON.stringify(selectedTab));
  }, [selectedTab]);

  const tcsCheckPay = selectedAccount?.find((item) => item.accountsid === '01' && item.selectedTab === 5);
  const tcsCheckRec = selectedAccount?.find((item) => item.accountsid === '02' && item.selectedTab === 5);
  const tdsCheckPay = selectedAccount?.find((item) => item.accountsid === '03' && item.selectedTab === 5);
  const tdsCheckRec = selectedAccount?.find((item) => item.accountsid === '04' && item.selectedTab === 5);

  const recOut = selectedAccount?.find((item) => item.accountsid === '010' && item.selectedTab === 7);
  const recAge = selectedAccount?.find((item) => item.accountsid === '020' && item.selectedTab === 7);
  const payOut = selectedAccount?.find((item) => item.accountsid === '030' && item.selectedTab === 7);
  const payAge = selectedAccount?.find((item) => item.accountsid === '040' && item.selectedTab === 7);
  const selectAcc = (() => {
    try {
      const stored = localStorage.getItem('selectedAccount');
      const parsedStored = stored && stored !== 'undefined' && stored !== 'null' ? JSON.parse(stored) : [];

      // If current tab is not 1, 2, or 3, return empty array
      if (selectedTab !== 1 && selectedTab !== 2 && selectedTab !== 3 && selectedTab !== 6 && selectedTab !== 9) {
        return [];
      }

      return selectedAccount?.length === 0 && parsedStored?.length > 0 ? parsedStored : selectedAccount;
    } catch (error) {
      console.error('Error parsing selectedAccount from localStorage in selectAcc:', error);
      return selectedAccount;
    }
  })();
  const eWayBill = selectAcc?.find((item) => item.accountsid === '004');
  const checkStockLedger = selectedAccount?.find((item) => item.accountsid === '101');
  const checkItemWisePandl = selectedAccount?.find((item) => item.accountsid === '102');

  const gstReport = selectAcc?.find((item) => ['001', '002', '003'].includes(item.accountsid));
  console.log(tableData, 'tableData');

  return (
    <Box>
      <Header
        data={heading}
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
        setBackdropOpen={setBackdropOpen}
        list={data}
        backdropOpen={backdropOpen}
        loading={loading}
        setList={setData}
        setTableData={setTableData}
        setGSTData={setGSTData}
        tableData={tableData}
        selectedAccount={selectedAccount}
        includeOpeningBalance={includeOpeningBalance}
        setSelectedAccount={setSelectedAccount}
      />
      <Grid container lg={12}>
        {selectedTab === 4 && (
          <Grid item container lg={1.8}>
            <Grid item lg={7} sx={{ marginTop: '15px' }}>
              <Typography
                variant="h1"
                sx={{
                  color: theme?.palette?.TmId.id.toString().includes('9') ? '#f9f9fe' : '#26282A',
                }}
              >
                Day Book
              </Typography>
            </Grid>
            <Grid item lg={5} sx={{ marginTop: '15px' }}>
              <Tooltip title="Search" placement="top">
                <Button
                  sx={{
                    borderWidth: '3px',
                    marginLeft: '5px',
                    marginBottom: '4px',
                    borderColor: 'primary.main',
                    borderStyle: 'solid',
                    backgroundColor: showSearch === true && '#f3724a',
                    whiteSpace: 'nowrap',
                    fontWeight: 'bold',
                    '&:active': {
                      transform: 'scale(0.92)',
                      boxShadow: 'inset 0px 0px 5px rgba(0, 0, 0, 0.4)',
                    },
                    '&:hover': {
                      backgroundColor: showSearch ? '#f3724a' : 'white',
                      // border: showSearch ? '2px solid white' : '1px solid white',
                    },
                    height: '28px',
                    minWidth: '10px',
                    width: '30px',
                  }}
                  variant="outlined"
                >
                  <SearchIcon
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowSearch((prev) => !prev);
                    }}
                    sx={{ fontSize: 20 }}
                  />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={12}
          md={selectedTab === 4 ? 10 : 12}
          lg={selectedTab === 4 ? 10 : 12}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'column', md: 'row' },
              justifyContent: { xs: 'center', md: 'space-between' },
              flexWrap: { md: 'wrap' },
              mt: { xs: 1, sm: 0.5 },
              gap: { xs: 2, sm: 1, md: 0 },
              width: '100%',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: { xs: 'center', sm: 'center' },
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 2, sm: 1 },
                width: { xs: '100%', md: 'auto' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: { xs: 'center', sm: 'center' },
                  flexDirection: { xs: 'column', sm: 'row' },
                  pl: { xs: 0, md: 1, lg: selectedTab !== 4 && 4 },
                  gap: 1,
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                <ActionItems
                  selectedTab={selectedTab}
                  anchorEl={anchorEl}
                  tdsbool={tcsCheckRec || tcsCheckPay || tdsCheckPay || tdsCheckRec}
                  setAnchorEl={setAnchorEl}
                  title={selectedTab === 7 ? 'Report As On' : 'Period'}
                  page={'report'}
                  outstandingPeriod={
                    selectedTab === 7 && dashboardData['bsPeriod'].startTimeStamp
                      ? dashboardData['bsPeriod'].range
                      : selectedTab === 7 && 'day'
                  }
                  showDateRangeText={true}
                  openingBalanceRequired={selectedTab == 1 || selectedTab == 2 || selectedTab === 3 || (selectedTab === 9 && checkItemWisePandl)}
                  isCustomDateModalOpen={isCustomDateModalOpen}
                  setIsCustomDateModalOpen={setIsCustomDateModalOpen}
                  includeOpeningBalance={includeOpeningBalance}
                  setIncludeOpeningBalance={setIncludeOpeningBalance}
                />
              </Box>
            </Box>
            {selectedAccount && selectedAccount?.length > 0 && (
              <Box
                className="DbTools"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  pr: { xs: '0px', sm: '20px' },
                  m: { xs: 0, sm: 1 },
                  gap: '5px',
                  width: { xs: '100%', md: 'auto' },
                }}
              >
                <Tooltip title="Print" arrow>
                  <Button
                    disableRipple
                    disableElevation
                    variant="outlined"
                    sx={{
                      // backgroundColor: 'bodyGray.main',
                      fontSize: { xs: '9px', sm: '10px' },
                      border: '1px solid',
                      borderColor: 'bodyGray.main',
                      boxShadow: `
              inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
              0 0 0 1px hsla(0, 0%, 0%, 0.05),
              0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
              0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
              0 3.5px 6px hsla(0, 0%, 0%, 0.09)
            `,
                      minWidth: { xs: '12px', sm: '15px', md: '25px' },
                      height: { xs: '26px', sm: '30px' },
                      backgroundColor: '#f9f9fe',
                    }}
                  >
                    <LocalPrintshop sx={{ fontSize: { xs: '18px', sm: '24px' } }} />
                  </Button>
                </Tooltip>

                <DbExportButton startDate={startTimeStamp} endDate={endTimeStamp} selectedTab={selectedTab} />
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item lg={2} sx={{ marginTop: '5px' }}></Grid>
      </Grid>
      {selectedTab !== 7 && selectedTab !== 8 && selectedTab !== 5 && (
        <ReportTable
          data={tableData}
          setTableData={setTableData}
          dayBookData={dayBookData}
          setDayBookData={setDayBookData}
          gstData={gstData}
          showSearch={showSearch}
          selectedTab={selectedTab}
          includeOpeningBalance={includeOpeningBalance}
          listOfStates={listOfStates}
          selectedAccount={selectedAccount}
          dataCount={dataCount}
          ledgersData={data}
          setdataCount={setdataCount}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          dayBookList={dayBookList}
          handleChangePage={handleChangePage}
        />
      )}
      {selectedTab === 5 && tcsCheckPay && <NewTDSTCSReport reportType={'TCSPAY'} tableName={'TCS Payable Report'} />}
      {selectedTab === 5 && tcsCheckRec && <NewTDSTCSReport reportType={'TCSREC'} tableName={'TCS Receivable Report'} />}
      {selectedTab === 5 && tdsCheckPay && <NewTDSTCSReport reportType={'TDSPAY'} tableName={'TDS Payable Report'} />}
      {selectedTab === 5 && tdsCheckRec && <NewTDSTCSReport reportType={'TDSREC'} tableName={'TDS Receivable Report'} />}
      {selectedTab === 7 && recOut && <NewOutStandingReport reportType={'ReceivableOutStanding'} tableName={'Receivable'} />}
      {selectedTab === 7 && recAge && <NewPayableReceivableAgeing reportType={'ReceivableOutStanding'} tableName={'Receivable Ageing'} />}
      {selectedTab === 7 && payOut && <NewOutStandingReport reportType={'PayableOutStanding'} tableName={'Payable'} />}
      {selectedTab === 7 && payAge && <NewPayableReceivableAgeing reportType={'PayableOutStanding'} tableName={'Payable Ageing'} />}
      {eWayBill && selectedTab === 6 && <ListEwayBill startTimeStamp={startTimeStamp} endTimeStamp={endTimeStamp} />}
      {gstReport && selectedTab === 6 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
            borderRadius: '8px',
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              fontSize: '2rem',
              color: '#ffa500',
              textShadow: '2px 2px 4px rgba(73, 70, 70, 0.5)',
            }}
          >
            Rolling out soon...
          </Typography>
        </Box>
      )}{' '}
      {selectedTab === 9 && checkStockLedger && (
        <ClosingStockSummary variant="component" includeOpeningBalance={selectedTab === 9 ? includeOpeningBalance : true} />
      )}
      {selectedTab === 9 && checkItemWisePandl && (
        <StockItemWiseSummary variant="component" includeOpeningBalance={selectedTab === 9 ? includeOpeningBalance : true} />
      )}
      {selectedTab === '' && (
        <Box
          sx={{
            width: '80vw',
            height: '70vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: theme?.palette?.TmId.id.toString().includes('9') ? '#f9f9fe' : '#26282A',
          }}
        >
          <Typography variant="h4">Please select a report</Typography>
        </Box>
      )}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default NewReports;
